import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { SdirButton, TextLink } from '@sdir/sds';

interface FormNavigationProps {
  backButtonText: string;
  backButtonLink?: string;
  nextButtonText: string;
  nextButtonLink?: string;
  backButtonOnClick?: ((e?: any) => void) | null;
  nextButtonOnClick?: ((e?: any) => void) | null;
  nextDisabled?: boolean;
  backDisabled?: boolean;
}

const FormNavigation: React.FC<FormNavigationProps> = ({
  backButtonLink,
  nextButtonLink,
  ...props
}) => {
  return (
    <ButtonsSection>
      {backButtonLink ? (
        <Link to={backButtonLink}>
          <BackButton {...props} />
        </Link>
      ) : (
        <BackButton {...props} />
      )}

      {nextButtonLink ? (
        <Link to={nextButtonLink}>
          <NextButton {...props} />
        </Link>
      ) : (
        <NextButton {...props} />
      )}
    </ButtonsSection>
  );
};

const NextButton: React.FC<FormNavigationProps> = ({
  nextButtonOnClick,
  nextButtonText,
  nextDisabled,
}) => (
  <SdirButton
    onClick={nextButtonOnClick || undefined}
    type="primary"
    text={nextButtonText}
    htmlType="button"
    disabled={nextDisabled}
  />
);

const BackButton: React.FC<FormNavigationProps> = ({
  backDisabled,
  backButtonText,
  backButtonOnClick,
}) => (
  <TextLink
    disabled={backDisabled}
    size="2rem"
    text={backButtonText}
    onClick={backButtonOnClick || undefined}
  />
);

const ButtonsSection = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 2rem 0;
`;

export default FormNavigation;
